'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { DoubleHalfCircleIcon } from '@nwwp/ui-shadcn'
import { funnelSchema } from '~/lib/schemas/funnel-schema'
import { useFunnelStore } from '../../_hooks/use-funnel-store'
import type { FunnelStepComponent } from '../../types'
import { FunnelStep } from '../FunnelStep'

const schema = funnelSchema.pick({ age: true })

export const Age: FunnelStepComponent = ({ onSubmit }) => {
  const age = useFunnelStore.getState().data.age as number | undefined
  const { control, formState, handleSubmit } = useForm({
    resolver: zodResolver(schema),
    defaultValues: { age },
    mode: 'onChange',
  })

  return (
    <FunnelStep onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-col gap-6">
        <div className="flex items-center gap-4 tablet:gap-8">
          <h1 className="relative z-10 text-title-2xl text-white">We&rsquo;re different than traditional advisors.</h1>
          <DoubleHalfCircleIcon className="hidden shrink-0 tablet:block" />
        </div>
        <div className="rounded-2xl bg-card p-4 text-body text-foreground">
          NerdWallet Wealth Partners takes a different approach to financial planning. For starters, we are a fee-only
          firm with transparent fees that max out at 0.9% if you invest $100K+. Our advisors specialize in helping
          high-earning professionals, keeping their plan and investments aligned with evolving career changes and
          priorities. We regularly hold strategy sessions and provide clear advice when big financial decisions arise.
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <FunnelStep.Title>What&rsquo;s your age?</FunnelStep.Title>
          <FunnelStep.Subtitle>Tell us a bit about yourself</FunnelStep.Subtitle>
        </div>
        <FunnelStep.NumberInput control={control} name="age" placeholder="Age" autoFocus />
        <FunnelStep.Button disabled={!formState.isValid}>Next</FunnelStep.Button>
      </div>
    </FunnelStep>
  )
}

Age.schema = schema
Age.path = 'age'
Age.pageActionSteps = ['age']
